// extracted by mini-css-extract-plugin
export default {"btn":"Button_btn__W1TTO","isLoading":"Button_isLoading__caVPs","ldsDualRing":"Button_ldsDualRing__7oKWf","lds-dual-ring":"Button_lds-dual-ring__Y7+rY"};